import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router, { asyncRoutes } from './router'
import store from './store'
import { UserModule } from '@/model/user';
import { filterAsyncRoutes } from './router/asyncRouter'
import '@/assets/css/reset_ele.scss'
import "@/assets/css/reset.css"
import "@/assets/css/iconfont.css"
import VueAMap from "vue-amap"
import Print from 'vue-print-nb'

Vue.config.productionTip = false

Vue.use(Element)
Vue.use(VueAMap)
Vue.use(Print)
VueAMap.initAMapApiLoader({
  key: '89bf01f52b9f96eff3cba83e20c6cc06',
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
  v: '1.4.4',
  uiVersion: '1.0'
})

Vue.filter('emptyIfFalsy', function(value:any) {
  return value ? value : '--';
});

// 标记是否已经加载过路由
let hasLoadedRoutes = false

// 确保router已经初始化后再添加导航守卫
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem("token");
//   if (to.meta && to.meta.without_auth) {
//     next();
//     return;
//   }

//   if (!token) {
//     next("/login");
//     return;
//   }

//   // 如果没有路由，添加路由
//   if (!store.state.route) {
//     // 写死的测试权限，开放所有路由
//     const mockPermissions = 'home,auth,auth/admin,auth/admin/edit,auth/role,auth/role/edit'
    
//     console.log('Using mock permissions:', mockPermissions)
    
//     // 过滤路由
//     const accessRoutes = filterAsyncRoutes(asyncRoutes, mockPermissions)
//     console.log('Filtered routes:', accessRoutes)
    
//     // 添加路由
//     accessRoutes.forEach(route => {
//       router.addRoute(route)
//     })
    
//     // 保存到 store
//     store.commit('saveRoute', accessRoutes)
//     store.commit('setPermissions', mockPermissions)
    
//     // 重新访问当前路由
//     next({ path: to.path, replace: true })
//     return
//   }

//   next()
// })

export const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
